export default "### Online Advertisements\n";